export default [
  {
    templates: ['header'],
    path: window.Moonbase.paths.header,
  }
];
